/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var DAYS;
(function (DAYS) {
    DAYS["SUNDAY"] = "Sunday";
    DAYS["MONDAY"] = "Monday";
    DAYS["TUESDAY"] = "Tuesday";
    DAYS["WEDNESDAY"] = "Wednesday";
    DAYS["THURSDAY"] = "Thursday";
    DAYS["FRIDAY"] = "Friday";
    DAYS["SATURDAY"] = "Saturday";
})(DAYS || (DAYS = {}));
